module.exports = __webpack_public_path__ + "img/EMT-PDAC_GSE205354.365f59c1.png";